//
//
//
//
//
//
//
//
//
import Swal from 'sweetalert2';
import ForgotPasswordForm from './forms/ForgotPasswordForm';
export default {
  name: 'ForgotPassword',

  data() {
    return {
      errors: {}
    };
  },

  methods: {
    onSubmit(data) {
      const toast = Swal.mixin({
        heightAuto: false
      });
      const p = this.$store.dispatch('users/forgotPassword', data);
      p.then(responseData => {
        this.$refs.form.reset();
        toast.fire({
          icon: 'success',
          text: responseData.message,
          title: 'Success'
        }).then(() => {
          window.location.replace('/login');
        });
      });
      p.catch(response => {
        const responseData = response.responseJSON;

        if (responseData && responseData.errors) {
          this.errors = responseData.errors;
        }

        if (responseData && responseData.message) {
          toast.fire({
            icon: 'error',
            text: responseData.message,
            title: 'Form Failed',
            heightAuto: false
          });
        }
      });
      this.errors = {};
    }

  },
  components: {
    ForgotPasswordForm
  }
};